import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';

const { GREY, PURPLE, LIGHT_GREY, WHITE } = colors;
const HeaderStyles = makeStyles((theme) => ({
	contentWrapper: {
		'@media (min-width:1920px)': {
			padding: '0 42px',
		},
		'@media (min-width:1440px)': {
			padding: '0 22px',
		},
		'@media (min-width:1026px)': {
			padding: '0 32px',
		},
		'@media (min-width:768px)': {
			padding: '0 16px',
		},
		'@media (min-width:360px)': {
			padding: '0 16px',
		},
		'@media (min-width:0px)': {
			padding: '0 16px',
		},
		'@media (max-width: 680px)': {
			marginTop: '0px !important',
		},
	},
	menuFiltersRight: {
		display: 'flex',
		justifyContent: 'end',
		marginRight: '52px',
		marginBottom: '15px',
		alignItems: 'center !important',
		'@media (max-width: 1276px)': {
			alignItems: 'flex-end !important',
			marginBottom: '16px',
		},
	},
	iconGrid: {
		[theme.breakpoints.up('md')]: {
			maxWidth: '14%',
			padding: '0 12px',
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: '10%',
			padding: '0 12px',
		},
	},
	salesContainer: {
		[theme.breakpoints.down('sm')]: {
			marginTop: '25px',
		},
		[theme.breakpoints.up('sm')]: {
			marginTop: '0',
		},
		[theme.breakpoints.up('lg')]: {
			marginTop: '0',
		},
		'@media (max-width:960px)': {
			marginTop: '75px',
		},
	},
	indicator: {
		borderRadius: '100px 100px 0px 0px',
		background: PURPLE,
		height: 4,
	},
	appBar: {
		height: 104,
		padding: '0px 16px 16px',
	},
	title: {
		float: 'left',
		fontFamily: 'Bogle-Regular !important',
		fontWeight: 'normal',
		color: theme.palette?.text?.main,
		fontSize: 24,
		marginLeft: 4,
		lineHeight: '64px',
		wordBreak: 'keep-all',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		[theme.breakpoints?.down('md')]: {
			fontSize: 20,
			marginLeft: 0,
		},
	},
	searchIcon: {
		'@media (min-width:1920px)': {
			marginRight: '36px',
		},
		'@media (max-width:920px)': {
			marginRight: '-20px',
		},
	},
	iconStyle: {
		color: GREY,
		padding: 7,
	},
	logoStyle: {
		height: 40,
		width: 16,
	},
	ProfileLogo: {
		height: 32,
		width: 64,
	},
	tabsContainer: {
		paddingTop: 8,
		color: PURPLE,
	},
	iconsContainer: {
		paddingTop: 32,
	},
	iconButton: {
		padding: '0 12px',
	},
	iconsItems: {
		border: `1px solid ${LIGHT_GREY}`,
		borderRadius: '50%',
		margin: '3px 12px',
		height: 40,
		width: 40,
		backgroundColor: PURPLE,
		color: WHITE,
	},
	userIcon: {
		paddingTop: 3,
	},
	turnSmall: {
		textTransform: 'lowercase',
	},
	headerInsights: {
		width: '100%',
		fontSize: '24px',
		fontFamily: 'Bogle-Regular !important',
		fontWeight: 700,
		borderBottom: '1px solid #E3E4E5',
		alignItems: 'center',
		padding: '24px 20px 0 20px',
		//gap: '16px',
		boxSizing: 'border-box !important',
	},
}));

export default HeaderStyles;
